import {
  CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING,
  CAMPAIGN_ON_BOARDING,
  CONTENT_EXPLORER_ONBOARDING,
  CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING,
  ON_BOARDING_ENUMS,
  OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING,
} from "constants/types";
import { setOnBoardingStepService } from "modules/Services/LoginService";
import store from "store";

export const startOnboardingCampaignsAssetsHomepage = () => {
  store.dispatch({ type: CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING.SHOW });
};

export const showCreateCampaignTryItNow = () => {
  store.dispatch({ type: CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING.SHOW });
};

export const hideCreateCampaignTryItNow = () => {
  store.dispatch({ type: CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING.HIDE });
};

export const setCreateCampaignStep = (step: number) => {
  store.dispatch({ type: CREATE_CAMPAIGN_TRY_IT_NOW_ONBOARDING.SET_STEP, payload: step });
};

export const setCampaignAndEmailsStep = (step: number, turnOff?: boolean) => {
  store.dispatch({
    type: CAMPAIGNS_ASSETS_HOMEPAGE_ONBOARDING.SET_STEP,
    payload: { step, value: turnOff ? 0 : 1 },
  });
  const values: any = {
    key: ON_BOARDING_ENUMS.CAMPAIGNS_AND_EMAILS,
    step: step.toString(),
  };
  if (turnOff) {
    values[ON_BOARDING_ENUMS.CAMPAIGNS_AND_EMAILS] = "0";
  } else {
    values[ON_BOARDING_ENUMS.CAMPAIGNS_AND_EMAILS] = "1";
  }
  setOnBoardingStepService(values)
    .then((res) => {
      console.log("setCampaignEmails Response : ", res);
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const showCampaignFirstTimeExplore = () => {
  store.dispatch({ type: OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING.SHOW });
};

export const hideCampaignFirstTimeExplore = () => {
  store.dispatch({ type: OPEN_CAMPAIGN_FIRST_TIME_ONBOARDING.HIDE });
};

export const setContentExplorerStep = (step: number, turnOff?: boolean) => {
  store.dispatch({
    type: CONTENT_EXPLORER_ONBOARDING.SET_STEP,
    payload: { step, value: turnOff ? 0 : 1 },
  });
  if (step > 9) return;
  const values: any = {
    key: ON_BOARDING_ENUMS.CONTENT_EXPLORER,
    step: step.toString(),
  };
  if (turnOff) {
    values[ON_BOARDING_ENUMS.CONTENT_EXPLORER] = "0";
  } else {
    values[ON_BOARDING_ENUMS.CONTENT_EXPLORER] = "1";
  }
  setOnBoardingStepService(values)
    .then((res) => {
      // console.log("setContentExplorerStep Response : ", res);
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const setContentExplorerBlogItemId = (id: any) => {
  store.dispatch({ type: CONTENT_EXPLORER_ONBOARDING.SET_ID, payload: id.toString() });
};

export const showCheckBlogTryItNow = () => {
  store.dispatch({ type: CONTENT_EXPLORER_ONBOARDING.SHOW_CHECKBOX_TRY_NOW });
};

export const hideCheckBlogTryItNow = () => {
  store.dispatch({ type: CONTENT_EXPLORER_ONBOARDING.HIDE_CHECKBOX_TRY_NOW });
};

export const setCampaignDashboardStep = (step: number, turnOff?: boolean) => {
  store.dispatch({
    type: CAMPAIGN_ON_BOARDING.DASHBOARD_SET_STEP,
    payload: { step, value: turnOff ? 0 : 1 },
  });
  const values: any = {
    key: ON_BOARDING_ENUMS.CAMPAIGNS,
    step: step.toString(),
  };
  if (turnOff) {
    values[ON_BOARDING_ENUMS.CAMPAIGNS] = "0";
  } else {
    values[ON_BOARDING_ENUMS.CAMPAIGNS] = "1";
  }
  setOnBoardingStepService(values)
    .then((res) => {
      console.log("setCampaignEmails Response : ", res);
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const setCampaignSmartSourceStep = (step: number, turnOff?: boolean) => {
  store.dispatch({
    type: CAMPAIGN_ON_BOARDING.SMART_SOURCE_SET_STEP,
    payload: { step, value: turnOff ? 0 : 1 },
  });
  const values: any = {
    key: ON_BOARDING_ENUMS.CAMPAIGNS_SMARTSOURCE,
    step: step.toString(),
  };
  if (turnOff) {
    values[ON_BOARDING_ENUMS.CAMPAIGNS_SMARTSOURCE] = "0";
  } else {
    values[ON_BOARDING_ENUMS.CAMPAIGNS_SMARTSOURCE] = "1";
  }
  setOnBoardingStepService(values)
    .then((res) => {
      console.log("setCampaignEmails Response : ", res);
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const setCampaignAudienceStep = (step: number, turnOff?: boolean) => {
  store.dispatch({
    type: CAMPAIGN_ON_BOARDING.AUDIENCE_SET_STEP,
    payload: { step, value: turnOff ? 0 : 1 },
  });
  const values: any = {
    key: ON_BOARDING_ENUMS.CAMPAIGNS_AUDIENCE,
    step: step.toString(),
  };
  if (turnOff) {
    values[ON_BOARDING_ENUMS.CAMPAIGNS_AUDIENCE] = "0";
  } else {
    values[ON_BOARDING_ENUMS.CAMPAIGNS_AUDIENCE] = "1";
  }
  setOnBoardingStepService(values)
    .then((res) => {
      console.log("setCampaignEmails Response : ", res);
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const setCampaignSmartSourceUpdateKeyword = (status: boolean) => {
  store.dispatch({
    type: CAMPAIGN_ON_BOARDING.SMART_SOURCE_SET_UPDATE_KEYWORD,
    payload: status,
  });
};

export const setCampaignAudienceListSelected = (status: boolean) => {
  store.dispatch({
    type: CAMPAIGN_ON_BOARDING.AUDIENCE_SET_SELECTED_LIST,
    payload: status,
  });
};

export const setCampaignAudienceListShow = (status: boolean) => {
  store.dispatch({
    type: CAMPAIGN_ON_BOARDING.AUDIENCE_SET_SHOW_LIST,
    payload: status,
  });
};
